export class PasswordResetModel {
    LoginID: number;
    Password: string;
    ConfirmPassword:string;
}
export class ChangePasswordModel {
    OldPassword: string;
    NewPassword: string;
    ConfirmNewPassword: string;
}